import React from 'react';
import { ViewControls } from 'shared/components/ViewControls';
import { TransparentButton } from 'shared/components/Buttons';

export interface ControlsProps {
  onExport: () => void;
}

export const Controls: React.FC<ControlsProps> = ({ onExport }) => (
  <ViewControls showTitle={false}>
    <TransparentButton text="Export" iconSrc="Download" onClick={onExport} />
  </ViewControls>
);
